import React from 'react';

export const LOGO_IMAGE = 'https://media-manager-c.questera.ai/greta-media/29d79c4109d1c19c2e75790b8e50872c9a33c9d5ce79f6f43f60effe48b91ada6d4fe9244bdd866a6b5eb503d1d2a9a7/images/aW1hZ2UvcG5n/85d412b21d70be91fe96cb5d5be606d2.png';
export const MASCOT_IMAGE = '/otterworks-reference.png';

export function Brand({ light = false }) {
  return (
    <a
      className={`brand ${light ? 'brand-light' : ''}`}
      href="#home"
      aria-label="OtterWorks home"
    >
      <img className="brand-logo" src={LOGO_IMAGE} alt="OtterWorks Engineering" />
    </a>
  );
}

export function Mascot({ className = '', alt = 'OtterWorks mascot' }) {
  return (
    <div className={`mascot-crop ${className}`}>
      <img src={MASCOT_IMAGE} alt={alt} />
    </div>
  );
}